import { Grid, Button } from "@mui/material";
import { SearchParticipantProps } from "../interfaces/interfaces";
import { SearchParticipantContext } from "../context/searchParticipantContext";
import React from "react";
import SearchParticipantByName from "../../../components/inputs/searchParticipantByName/searchParticipantByName";

const SearchForm = (): React.JSX.Element => {
  const {
    searchParameters,
    setSearchParameters,
    startSearch,
  }: {
    searchParameters: SearchParticipantProps;
    setSearchParameters: (searchParameters: SearchParticipantProps) => void;
    startSearch: () => void;
  } = React.useContext(SearchParticipantContext);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        startSearch();
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sm={8} md={10}>
          <SearchParticipantByName
            disabled={searchParameters.loading}
            required
            name={searchParameters.participantName}
            onChange={(name: string) =>
              setSearchParameters({
                ...searchParameters,
                participantName: name,
              })
            }
          />
        </Grid>

        <Grid item xs={12} sm={4} md={2}>
          <Button
            disabled={
              searchParameters.participantName === "" ||
              searchParameters.loading
            }
            onClick={() => startSearch()}
            sx={{
              height: "100%",
              width: "100%",
            }}
            variant="contained"
            color="primary"
          >
            Suchen
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default SearchForm;
